import React, { useState, useEffect, useRef } from "react";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import Logout from "./Logout";
import Card from "react-bootstrap/Card";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { getMainAssets, getRoleMaster, getroleAssetMapping, setroleAssetMapping } from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import axios from "axios";
import Loader from '../Utilities/Loader';
import { Button, Modal } from 'react-bootstrap';
import { customStyles } from "../Utilities/utils";
import Select from "react-select";

const RoleAssetMapping = ({ }) => {
  const [submitResponse, setsubmitResponse] = useState('');
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [roleData, setroleData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [maindropdowndata, setMaindropdowndata] = useState([]);
  const [cardsData, setCardsData] = useState([]);
  const [mainAssert, setMainAssert] = useState('');
  const [roleId, setroleId] = useState('');
  const [errorRole, setErrorRole] = useState('');
  const [errorMain, setErrorMain] = useState('');
  const [showMsg, setShowMsg] = useState('false');
  const [showsubmit, setShowsubmit] = useState(false);

  const handleSelection = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleMainAssertChange = (e) => {
    // console.log("handleMainAssertChange:: ", e.target.value);
    setMainAssert(e.target.value);
    // setTimeout(() => {
    fetchCardData(e.target.value);
    // alert(e.target.value);
  };

  const handleRoleChange = (e) => {
    console.log(e.target.value);
    setroleId(e.target.value);
    setMainAssert('');
    fetchMainDropdownData(e.target.value);
  };

  const handleresponse = () => {
    setShowResponsePopup(false);
    window.location.reload();
  }

  const handleRoleDopdowndata = async () => {
    const apiUrl = getRoleMaster;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    axios.get(apiUrl, { headers })
      .then((response) => {
        console.log("responserOLE", response);
        setroleData(response.data.response.roleMaster)

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error fetching data:', error);
      });
  };
  const fetchMainDropdownData = async (roleId) => {

    const apiUrl = getMainAssets;
    const headers = await GetApiHeaders();
    if (roleId != null && roleId != '') {
      setIsLoading(false);

      axios.get(apiUrl, { headers })
        .then((response) => {
          console.log("response", response);
          setMaindropdowndata(response.data.response.MainAssetMaster)
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error('Error fetching data:', error);
        });
    }
  }
  useEffect(() => {
    // fetchMainDropdownData();
    handleRoleDopdowndata();
    console.log("use Effect mainAssert", mainAssert);
  }, [mainAssert]);

  const fetchCardData = async (mainassertid) => {
    console.log("mainAssert", mainassertid);
    const apiUrl = getroleAssetMapping;
    const headers = await GetApiHeaders();
    if (roleId !== '' && mainassertid !== '') {
      const dataToSend = {
        "id": roleId,
        "mainAssetId": mainassertid.toString()
      };
      setIsLoading(true);
      axios.post(apiUrl, dataToSend, { headers })
        .then((response) => {
          console.log("response", response);
          setCardsData(response.data.response.roleAssetMapping)
          setIsLoading(false);
          setShowsubmit(true);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error('Error fetching data:', error);
        });
    }
  }


  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    console.log("Submit clicked");

    try {
      var array = [];

      if (!cardsData || cardsData.length === 0) {
        console.log("cardsData is empty");
      } else {
        for (let index = 0; index < cardsData.length; index++) {
          if (
            !cardsData[index].subAssets ||
            cardsData[index].subAssets.length === 0
          ) {
            continue;
          }

          for (
            let sIndex = 0;
            sIndex < cardsData[index].subAssets.length;
            sIndex++
          ) {
            var obj = {
              assetId: cardsData[index].assetId,
              subAssetId:
                cardsData[index].subAssets[sIndex].subAssetId,
              isEditable:
                cardsData[index].subAssets[sIndex].editable,
              isViewStatus:
                cardsData[index].subAssets[sIndex].viewStatus,
            };

            array.push(obj);
          }
        }
      }

      var jsonData = {
        roleId: roleId,
        mainAssetId: mainAssert,
        assets: array,
      };

      console.log("jsonData:", jsonData);

      const apiUrl = setroleAssetMapping;
      console.log("apiUrl:", apiUrl);

      const headers = await GetApiHeaders();
      console.log("headers:", headers);

      setIsLoading(true);

      console.log("Before API Call");

      const response = await axios.post(
        apiUrl,
        jsonData,
        { headers }
      );

      console.log("After API Call");
      console.log("Response:", response.data);

      setsubmitResponse(response.data.response);
      setShowResponsePopup(true);
      setIsLoading(false);
    } catch (error) {
      console.error("API Error:", error);
      console.log("Error Message:", error.message);
      console.log("Error Response:", error.response);

      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (cardIndex, subAssetIndex, type) => {
    const updatedCardsData = [...cardsData];
    const subAsset = updatedCardsData[cardIndex].subAssets[subAssetIndex];
    console.log("subAsset::", JSON.stringify(subAsset));
    subAsset[type] = !subAsset[type];
    console.log("!subAsset::", JSON.stringify(subAsset));
    setCardsData(updatedCardsData);
  };

  const formatCamelCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  const roleOptions =
    roleData?.filter((item) => item.status === "1")
      .map((item) => ({
        value: item.id,
        label: item.roleName,
      })) || [];

  const mainAssetOptions =
    maindropdowndata?.filter((item) => item.status === "1")
      .map((item) => ({
        value: item.id,
        label: item.mainAssetName,
      })) || [];

  return (
    <body id="page-top">
      <div id="wrapper">
        <SideMenu />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text ml-3">
                          Role Asset Mapping
                        </h6>
                      </div>
                    </div>
                    <div className="dropdown-container mt-3">
                      <label className="role ml-3">
                        <b>Role&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;
                      </label>
                      <Select
                        options={roleOptions}
                        value={roleOptions.find(
                          (option) => String(option.value) === String(roleId)
                        )}
                        onChange={(selected) =>
                          handleRoleChange({
                            target: {
                              value: selected?.value || "",
                            },
                          })
                        }
                        placeholder="Select Role"
                        isClearable
                        isSearchable
                        styles={customStyles}
                      />
                      <label className="mainAsset">
                        <b>Main Asset&nbsp;&nbsp;&nbsp;:</b>&nbsp;&nbsp;&nbsp;
                      </label>
                      <Select
                        options={mainAssetOptions}
                        value={mainAssetOptions.find(
                          (option) => String(option.value) === String(mainAssert)
                        )}
                        onChange={(selected) =>
                          handleMainAssertChange({
                            target: {
                              value: selected?.value || "",
                            },
                          })
                        }
                        placeholder="Main Asset Master"
                        isClearable
                        isSearchable
                        styles={customStyles}
                      />
                    </div>
                    <div className="d-flex flex-row flex-wrap">
                      {(cardsData != undefined && cardsData?.length > 0) && cardsData?.map((card, cardIndex) => (
                        <div className="row mr-2 ml-2">
                          <div className="col-lg-6 col-md-6 p-2">
                            <div className="card mt-3" style={{
                              width: "33rem", height: "18rem", overflowY: "auto",
                            }}>
                              <div className="card-header"
                                style={{ backgroundColor: "#4A7729", color: "white", fontWeight: 500 }}>
                                {formatCamelCase(card.assetName)} {/*Dash board */}
                                <span className="edit mr-1">Edit</span>
                                <span className="view mr-2">View</span>
                              </div>
                              {card.subAssets.map((subAsset, subAssetIndex) => (
                                <div className="card-body">
                                  <div className="mt-2 ml-3">
                                    <div>
                                      <label className="label">{formatCamelCase(subAsset.subAssetName)}</label>
                                      <input type="checkbox" className="checkbox"
                                        checked={subAsset.editable}
                                        onChange={() =>
                                          handleCheckboxChange(cardIndex, subAssetIndex, "editable")
                                        } />
                                      <input type="checkbox" className="checkbox"
                                        checked={subAsset.viewStatus}
                                        onChange={() =>
                                          handleCheckboxChange(cardIndex, subAssetIndex, "viewStatus")
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {showsubmit && <Button variant="primary" sstyle={{ display: 'flex', gap: '10px' }} onClick={handleSubmit}>Submit</Button>}
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div>
              <Modal show={showResponsePopup} centered backdrop="static" keyboard={false} size="ml">
                <Modal.Header className="border-0 d-flex justify-content-center">
                  <Modal.Title>  <span className='modal_title'>Role Asset Mapping</span></Modal.Title>
                </Modal.Header>
                <Modal.Body className='pl-md-5 pr-md-5 pt-0' >
                  <div className='d-flex justify-content-center mb-3 font-weight-600'>
                    {showMsg ? (
                      <p style={{ color: '#4A7729' }} >{submitResponse}</p>
                    ) : null}
                  </div>
                  <div className="d-flex justify-content-center">
                    <Button variant="primary" className="d-flex justify-content-center cancel_button" onClick={handleresponse} >
                      Okay
                    </Button>&nbsp;&nbsp;
                  </div>
                </Modal.Body>
              </Modal>

            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <Logout />

    </body>
  );
};

export default RoleAssetMapping;
